import React from "react";
import { useTeamId } from "@coworker/app/src/core/auth/useLoggedInUser";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";

export function LandingPage() {
  const teamId = useTeamId();
  const navigate = useFixaNavigate();

  React.useEffect(() => {
    if (!teamId) {
      navigate("/teamselection", { replace: true });
    } else {
      navigate("/home", { replace: true });
    }
  }, [teamId, navigate]);

  return null;
}
